import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ variant = "horizontal", light = false, className = "", imgClassName = "" }) {
  const logoSrc = "https://assets.auxodev.dk/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/ses-multi-service-a-kvalitet-og-omsorg-1.png";

  if (variant === "compact") {
    return (
      <Link to="/" className={`inline-flex items-center group ${className}`} aria-label="Ses Multi Service Forside">
        <div className={`p-1 rounded-xl transition-all ${light ? 'bg-[#FAF7F2]/10 hover:bg-[#FAF7F2]/20' : 'hover:opacity-90'}`}>
          <img 
            src={logoSrc} 
            alt="Ses Multi Service" 
            className={imgClassName || "h-12 w-auto object-contain"} 
          />
        </div>
      </Link>
    );
  }

  if (variant === "footer") {
    return (
      <Link to="/" className={`inline-flex items-center group ${className}`} aria-label="Ses Multi Service Forside">
        <div className={`transition-all duration-200 group-hover:scale-[1.02] ${light ? 'p-1.5 bg-[#FAF7F2]/90 rounded-xl shadow-xs' : ''}`}>
          <img 
            src={logoSrc} 
            alt="Ses Multi Service" 
            className={imgClassName || "w-32 h-32 sm:w-40 sm:h-40 md:w-44 md:h-44 lg:w-48 lg:h-48 xl:w-56 xl:h-56 object-contain"} 
          />
        </div>
      </Link>
    );
  }

  return (
    <Link to="/" className={`inline-flex items-center group ${className}`} aria-label="Ses Multi Service Forside">
      <div className={`transition-all duration-200 group-hover:scale-[1.02] ${light ? 'p-1.5 bg-[#FAF7F2]/90 rounded-xl shadow-xs' : ''}`}>
        <img 
          src={logoSrc} 
          alt="Ses Multi Service" 
          className={imgClassName || "h-14 sm:h-18 lg:h-24 xl:h-28 w-auto object-contain max-w-[280px] sm:max-w-[340px] lg:max-w-[440px] xl:max-w-[540px]"} 
        />
      </div>
    </Link>
  );
}
